export const ABBREVIATED_PANORAMA_INVOICE_STATUS = {
  PAYMENT_ON_TIME: 'P1',
  PAID_LATE_10: 'L1',
  PAID_LATE_30: 'L2',
  PAID_LATE_60: 'L3',
  PAID_LATE_90: 'L4',
  PAID_LATE_90_MORE: 'L5',
  PAYABLE: 'A1',
  AWAITING_GEN_OV: 'F1',
  NEEDS_UPDATE_ADDRESS: 'F2',
  NEEDS_CREATE_USER: 'F3',
  AWAITING_GEN_BOLETO: 'F4',
  AWAITING_SEND_EMAIL: 'F5',
  INFORMAL_AGREEMENT: 'D1',
  SIGNED_AGREEMENT: 'D2',
  OUTSOURCED_AGREEMENT: 'D3',
  DO_NOT_CHARGE: 'O1',
  CHARGE_BY_CELLPHONE: 'O2',
  PAYMENT_WITH_DATE: 'O3',
  USUALLY_PAID_LATE: 'O4',
  SEND_SERASA: 'S1',
  REGISTERED_SERASA: 'S2',
  ENERGY_REPORT: 'E1',
  CONSUMING_BALANCE: 'E2',
  SEND_OUTSOURCED: 'T1',
  REGISTERED_OUTSOURCED: 'T2',
  ESPECIAL_JUSTICE: 'J1',
  COMMON_JUSTICE: 'J2',
  LOSS_OR_HARM: 'R1',
};

export const PANORAMA_INVOICE_STATUS = {
  PAYMENT_ON_TIME: '[P1] Em dia',
  PAID_LATE: '[P2] Em atraso',
  PAID_LATE_10: '[L1] Em atraso < 10 dias',
  PAID_LATE_30: '[L2] Em atraso < 30 dias',
  PAID_LATE_60: '[L3] Em atraso < 60 dias',
  PAID_LATE_90: '[L4] Em atraso < 90 dias',
  PAID_LATE_90_MORE: '[L5] Em atraso > 90 dias',
  PAYABLE: '[A1] A pagar',
  NEEDS_UPDATE_ADDRESS: '[F1] 365: Atualizar endereço',
  NEEDS_CREATE_USER: '[F2] 365: Criar usuário',
  AWAITING_GEN_OV: '[F3] Gerando OV',
  AWAITING_GEN_BOLETO: '[F4] Gerando boleto',
  AWAITING_SEND_EMAIL: '[F5] Enviando boleto',
  INFORMAL_AGREEMENT: '[D1] Acordo informal',
  SIGNED_AGREEMENT: '[D2] Acordo assinado',
  OUTSOURCED_AGREEMENT: '[D3] Acordo terceirizado',
  DO_NOT_CHARGE: '[O1] Não cobrar',
  CHARGE_BY_CELLPHONE: '[O2] Cobrar por telefone',
  PAYMENT_WITH_DATE: '[O3] Pagamento com data definida',
  USUALLY_PAID_LATE: '[O4] Normalmente paga em atraso',
  SEND_SERASA: '[S1] Enviar para Serasa',
  REGISTERED_SERASA: '[S2] Registrado no Serasa',
  ENERGY_REPORT: '[E1] Relatório de energia/duplicidade',
  CONSUMING_BALANCE: '[E2] Consumindo saldo',
  SEND_OUTSOURCED: '[T1] Enviar cobrança terceirizada',
  REGISTERED_OUTSOURCED: '[T2] Cobrança terceirizada registrada',
  ESPECIAL_JUSTICE: '[J1] Juizado especial',
  COMMON_JUSTICE: '[J2] Justiça comum',
  LOSS_OR_HARM: '[R1] Perda ou prejuízo',
};

export const PANORAMA_INVOICE_GROUPS = {
  TOTAL: '[TT] Total',
  PAID: '[PG] Pago',
  OPEN: '[AB] Aberto',
  AGREEMENT: '[DE] Acordo',
  OVERDUE: '[NA] Inadimplente',
  LOSS: '[RD] Perda',
};

export const PANORAMA_INVOICE_SUBGROUPS = {
  PAID_LATE: '[P2] Em atraso',
  NO_INVOICE: '[A2] Sem fatura',
  OPERATIONAL_CHARGE: '[CO] Cobrança operacional',
  CHARGE_NOTIFIED: '[CS] Cobrança notificada',
  CHARGE_ON_HOLD: '[CE] Cobrança em espera',
  OUTSOURCED_CHARGE: '[CT] Cobrança terceirizada',
  JUDICIAL_CHARGE: '[CJ] Cobrança judicial',
};

export const PANORAMA_INVOICE_GROUPED_STATUS = {
  TOTAL: '[TT] Total',
  PAID: {
    PAYMENT_ON_TIME: '[P1] Em dia',
    PAID_LATE: {
      PAID_LATE_10: '[L1] Em atraso < 10 dias',
      PAID_LATE_30: '[L2] Em atraso < 30 dias',
      PAID_LATE_60: '[L3] Em atraso < 60 dias',
      PAID_LATE_90: '[L4] Em atraso < 90 dias',
      PAID_LATE_90_MORE: '[L5] Em atraso > 90 dias',
    },
  },
  OPEN: {
    PAYABLE: '[A1] A pagar',
    NO_INVOICE: {
      NEEDS_UPDATE_ADDRESS: '[F1] 365: Atualizar endereço',
      NEEDS_CREATE_USER: '[F2] 365: Criar usuário',
      AWAITING_GEN_OV: '[F3] Gerando OV',
      AWAITING_GEN_BOLETO: '[F4] Gerando boleto',
      AWAITING_SEND_EMAIL: '[F5] Enviando boleto',
    },
  },
  AGREEMENT: {
    INFORMAL_AGREEMENT: '[D1] Acordo informal',
    SIGNED_AGREEMENT: '[D2] Acordo assinado',
    OUTSOURCED_AGREEMENT: '[D3] Acordo terceirizado',
  },
  OVERDUE: {
    OPERATIONAL_CHARGE: {
      DO_NOT_CHARGE: '[O1] Não cobrar',
      CHARGE_BY_CELLPHONE: '[O2] Cobrar por telefone',
      PAYMENT_WITH_DATE: '[O3] Pagamento com data definida',
      USUALLY_PAID_LATE: '[O4] Normalmente paga em atraso',
    },
    CHARGE_NOTIFIED: {
      SEND_SERASA: '[S1] Enviar para Serasa',
      REGISTERED_SERASA: '[S2] Registrado no Serasa',
    },
    CHARGE_ON_HOLD: {
      ENERGY_REPORT: '[E1] Relatório de energia/duplicidade',
      CONSUMING_BALANCE: '[E2] Consumindo saldo',
    },
    OUTSOURCED_CHARGE: {
      SEND_OUTSOURCED: '[T1] Enviar cobrança terceirizada',
      REGISTERED_OUTSOURCED: '[T2] Cobrança terceirizada registrada',
    },
    JUDICIAL_CHARGE: {
      ESPECIAL_JUSTICE: '[J1] Juizado especial',
      COMMON_JUSTICE: '[J2] Justiça comum',
    },
  },
  LOSS: {
    LOSS_OR_HARM: '[R1] Perda ou Prejuizo',
  },
};

export const OLD_TO_NEW_STATUS = {
  PAID: 'PAYMENT_ON_TIME',
  PAID_LATE_10: 'PAID_LATE_10',
  PAID_LATE_30: 'PAID_LATE_30',
  PAID_LATE_60: 'PAID_LATE_60',
  PAID_LATE_90: 'PAID_LATE_90',
  PAID_LATE_90_MORE: 'PAID_LATE_90_MORE',
  WAITING_PAYMENT: 'PAYABLE',
  LATE: 'DO_NOT_CHARGE',
  BILLING_STARTED: 'CHARGE_BY_CELLPHONE',
  NEGATIVE_OR_NONEXISTENT: 'SEND_SERASA',
  WAITING_BALANCE: 'CONSUMING_BALANCE',
  AWAITING_PAYMENT: 'PAYMENT_WITH_DATE',
  ENERGY_REPORT: 'ENERGY_REPORT',
  START_NOTIFICATION: 'SEND_SERASA',
  BROKEN_AGREEMENT: 'SEND_SERASA',
  JUDICIALIZE: 'SEND_OUTSOURCED',
  SEND_FRIENDLY_NOTIFY: 'SEND_SERASA',
  REGISTERED_FRIENDLY_NOTIFY: 'SEND_SERASA',
  SEND_SERASA: 'SEND_SERASA',
  REGISTERED_SERASA: 'REGISTERED_SERASA',
  SEND_PROTEST: 'SEND_OUTSOURCED',
  PROTEST: 'SEND_OUTSOURCED',
  CAUSES_TO_SEND: 'SEND_OUTSOURCED',
  REGISTERED_CAUSES: 'SEND_OUTSOURCED',
  LOSS_OR_HARM: 'LOSS_OR_HARM',
  INFORMAL_AGREEMENT: 'INFORMAL_AGREEMENT',
  AGREEMENT: 'SIGNED_AGREEMENT',
  OUTSOURCED_AGREEMENT: 'OUTSOURCED_AGREEMENT',
  AWAITING_GEN_OV: 'AWAITING_GEN_OV',
  NEEDS_UPDATE_ADDRESS: 'NEEDS_UPDATE_ADDRESS',
  NEEDS_CREATE_USER: 'NEEDS_CREATE_USER',
  AWAITING_GEN_BOLETO: 'AWAITING_GEN_BOLETO',
  AWAITING_SEND_EMAIL: 'AWAITING_SEND_EMAIL',
  EXTRAJUDICIAL_TO_NOTIFICATION: 'SEND_SERASA',
  EXTRAJUDICIAL_NOTIFIED: 'SEND_SERASA',
};

export const NEW_TO_OLD_STATUS = {
  PAYMENT_ON_TIME: 'PAID',
  PAID_LATE_10: 'PAID',
  PAID_LATE_30: 'PAID',
  PAID_LATE_60: 'PAID',
  PAID_LATE_90: 'PAID',
  PAID_LATE_90_MORE: 'PAID',
  PAYABLE: 'WAITING_PAYMENT',
  DO_NOT_CHARGE: 'LATE',
  CHARGE_BY_CELLPHONE: 'BILLING_STARTED',
  SEND_SERASA: 'SEND_SERASA', // Reutilizado em vários casos no OLD_TO_NEW_STATUS; aqui mapeamos apenas o primeiro encontrado
  CONSUMING_BALANCE: 'WAITING_BALANCE',
  PAYMENT_WITH_DATE: 'AWAITING_PAYMENT',
  ENERGY_REPORT: 'ENERGY_REPORT',
  SEND_OUTSOURCED: 'SEND_PROTEST', // Vários OLD mapeavam para SEND_OUTSOURCED; aqui usamos o primeiro encontrado
  REGISTERED_SERASA: 'REGISTERED_SERASA',
  LOSS_OR_HARM: 'LOSS_OR_HARM',
  INFORMAL_AGREEMENT: 'INFORMAL_AGREEMENT',
  SIGNED_AGREEMENT: 'AGREEMENT',
  OUTSOURCED_AGREEMENT: 'OUTSOURCED_AGREEMENT',
  AWAITING_GEN_OV: 'WAITING_GEN_INVOICE',
  NEEDS_UPDATE_ADDRESS: 'WAITING_GEN_INVOICE',
  NEEDS_CREATE_USER: 'WAITING_GEN_INVOICE',
  AWAITING_GEN_BOLETO: 'WAITING_GEN_INVOICE',
  AWAITING_SEND_EMAIL: 'WAITING_GEN_INVOICE',
};
